import styled from "styled-components";
import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import ThreatGuardOpportunityDropdown from "./ThreatGuardOpportunityDropdown";
import ThreatGuardCustomerDropdown from "./ThreatGuardCustomerDropdown";
import ThreatGuardDomains from "./ThreatGuardDomains";
import ThreatGuardIndustryDropdown from "./ThreatGuardIndustryDropdown";
import ThreatGuardCompanySizeDropdown from "./ThreatGuardCompanySizeDropdown";
import ThreatGuardMonthsTabs from "./ThreatGuardMonthsTabs";
import {useMutation} from "react-query";
import apiService from "../../../api/apiService";
import Loading from "../Loading";
import {validateForm} from "./formValidate";
import ModalContext from "../demoPointEnv/envResultsTable/ModalContext";


const FormContainer = styled.div`
  margin-top: 20px;

  .alert {
    color: red;
    font-weight: bold;
  }
  
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 465px;

  .alert {
    color: red;
    font-weight: bold;
  }

  .multiple-value-text-input .multiple-value-text-input-item {
    background: var(--color-sidebar-pink-selected);
    border-radius: 7px;
    margin-top: 5px;
    display: inline-block;
  }

  .input-customer-domains {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid var(--color-toggle-border);
    margin-top: 5px;

    &:focus-visible {
      outline-color: #EC407A;
    }
  }
`;
const InputContainer = styled.div`
  margin-top: 35px;
`;

const GenerateReportButton = styled.button`
  justify-content: center;
  align-items: center;
  width: 150px;
  color: white;
  background: #EC407A;
  padding: 1em 0;
  border: 1px solid #E5E5E5;
  cursor: pointer;
`;


const FormToGenerateReport = () => {
    const {handleSubmit} = useForm();
    const { setThreatGuardModalIsOpen, setContentMessage, setBasicModalIsOpen } = useContext(ModalContext);
    const [threatGuardFormData, setThreatGuardFormData] = useState({
        domains: "",
        customerName: "",
        industryName: "",
        companySize: "",
        opportunityName: "",
        opportunityNumber: "",
        threadGuardDaysReducer: "120",
        exclude_domains: ""
    });
    const [errors, setErrors] = useState([]);
    const {mutate: sendThreatGuardReport, isLoading} = useMutation(
        (formData) =>
            apiService.sendThreatGuardReport(formData),
        {
            onSuccess: (response) => {
                if (!response?.ok) {
                    console.error("Error in sendThreatGuardReport", response);
                    setContentMessage(["Error in generating ThreatGuard Report", "Please try again later"]);
                    setBasicModalIsOpen(true);
                    return;
                }

                setContentMessage(["Generating ThreatGuard Report", "ThreatGuard is scanning your domains."," An Email will be sent to you in a few minutes"]);
                setThreatGuardModalIsOpen(true);
            }
        }
    );
    const {mutate: contentCreated} = useMutation(
        (formData) =>
            apiService.contentCreated(formData)
    );

    const onSubmit = () => {
        setErrors(validateForm(threatGuardFormData));
    }

    useEffect(() => {
        if (errors.length === 0 && threatGuardFormData.domains.length > 0) {
            sendThreatGuardReport(
                {
                    protected_domains: threatGuardFormData.domains,
                    company: threatGuardFormData.customerName,
                    timeback: threatGuardFormData.threadGuardDaysReducer,
                    exclude_domains: threatGuardFormData.exclude_domains
                });
            contentCreated(
                {
                    DomainsList: threatGuardFormData.domains,
                    CustomerName: threatGuardFormData.customerName,
                    Industry: threatGuardFormData.industryName,
                    CompanySize: threatGuardFormData.companySize,
                    ScanPeriod: threatGuardFormData.threadGuardDaysReducer,
                    OpportunityName: threatGuardFormData.opportunityName,
                    opportunityNumber: threatGuardFormData.opportunityNumber,
                }
            );
        }
    }, [errors])

    if (isLoading) {
        return <Loading/>
    }

    return (
        <FormContainer>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <InputContainer>
                    <ThreatGuardDomains label={"Customer Domains(Up to 10 Domains)"} fieldName={"domains"}
                                        setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardCustomerDropdown label={"Customer Name"}
                                                 setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardOpportunityDropdown label={"Opportunity Number"}
                                                    setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardIndustryDropdown label={"Industry"} setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardCompanySizeDropdown label={"Company Size"}
                                                    setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardMonthsTabs label={"Period To Scan Back (Months)"}
                                           setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <ThreatGuardDomains label={"Lookalike Domains To Exclude (optional for top results improvements)"}
                                        fieldName={"exclude_domains"} setThreatGuardFormData={setThreatGuardFormData}/>
                </InputContainer>
                <InputContainer>
                    <GenerateReportButton id={"generate-report-btn"} type={"submit"}>
                        Generate Report
                    </GenerateReportButton>
                </InputContainer>
            </Form>
            {errors.length > 0 && errors.map(error => (
                <p className="alert" key={error}>{error}</p>
            ))}
        </FormContainer>
    );


}

export default FormToGenerateReport;
